import { Input, Radio } from "antd";

const CreateContractLieu = ({ contract, setContract, chantiers = [] }) => {
  const selectChantier = chantier => setContract(current => ({
    ...current,
    clientName: chantier.NomChantier || "",
    address: chantier.AdresseRue || "",
    postCode: chantier.AdresseCodePostal || "",
    town: chantier.AdresseVille || "",
  }));

  return (
    <div className="contractLocation">
      <h3 className="contractLocationTitle">Lieu de la mission</h3>
      <section className="contractSavedLocations">
        <h4>Lieux enregistrés dans TEMPO</h4>
        {chantiers.length ? <div className="contractLocationList">
          {chantiers.map((chantier, index) => (
            <button type="button" key={chantier.IdChantier || index} onClick={() => selectChantier(chantier)} className="contractLocationChoice">
              <strong>{chantier.NomChantier}</strong>
              <span>{[chantier.AdresseRue, chantier.AdresseSuite, chantier.AdresseCodePostal, chantier.AdresseVille].filter(Boolean).join(" · ")}</span>
            </button>
          ))}
        </div> : <p className="contractLocationEmpty">Aucun lieu enregistré.</p>}
      </section>
      <section className="contractLocationForm">
        <h4>Adresse de la mission</h4>
        <div className="contractLocationFields">
          {[
            ["clientName", "Client final", "Nom de l’entreprise"],
            ["address", "Adresse", "Numéro et nom de rue"],
            ["postCode", "Code postal", "Ex. 92600"],
            ["town", "Ville", "Ville de la mission"],
          ].map(([key, label, placeholder]) => (
            <label key={key} className={`contractLocationField contractLocationField-${key}`}>
              <span>{label}</span>
              <Input value={contract[key] || ""} placeholder={placeholder}
                onChange={event => setContract(current => ({ ...current, [key]: event.target.value }))} />
            </label>
          ))}
        </div>
      </section>
      <section className="contractMissionOptions" aria-label="Conditions de la mission">
        {[
          ["EstChezClient", "Est en chantier", "N", "O"],
          ["EstBTP", "Est BTP", "O", "N"],
          ["EstTransport", "Est transport", "O", "N"],
        ].map(([key, label, yes, no]) => (
          <div key={key} className="contractMissionOption">
            <p id={`contract-option-${key}`}>{label}</p>
            <Radio.Group aria-labelledby={`contract-option-${key}`} value={contract[key]}
              onChange={event => setContract(current => ({ ...current, [key]: event.target.value }))}>
              <Radio value={yes}>OUI</Radio>
              <Radio value={no}>NON</Radio>
            </Radio.Group>
          </div>
        ))}
      </section>
    </div>
  );
};

export default CreateContractLieu;
